import React, { Fragment } from "react";
import "./App.css";

import SalesForm from "./containers/sales-form-new/sales-form";

const App = () => (
  <Fragment>
    <SalesForm />
  </Fragment>
);

export default App;
